export default "__VITE_ASSET__DWNodkjp__"